var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecapUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.578,
    height: 40.029,
    viewBox: "0 0 25.578 40.029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(-29.661 -22.63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_182",
    "data-name": "Tracciato 182",
    d: "M78.22,93.553V91.085a6.025,6.025,0,0,1,6.022-6.025H95.777a6.025,6.025,0,0,1,6.021,6.025v9.071",
    transform: "translate(-47.559 -38.498)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_183",
    "data-name": "Tracciato 183",
    d: "M98.757,29.018A8.323,8.323,0,0,0,87.7,36.047a7.69,7.69,0,0,0,11.057-6.914v-.116",
    transform: "translate(-53.5 -3.077)",
    fill: "#e02027",
    stroke: "#e02027",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_184",
    "data-name": "Tracciato 184",
    d: "M84.46,37.341A8.452,8.452,0,0,0,97.309,30.55",
    transform: "translate(-51.47 -4.337)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_185",
    "data-name": "Tracciato 185",
    d: "M91.94,24.851,94.389,27.3V23.63",
    transform: "translate(-56.158 0)",
    fill: "none",
    stroke: "#e02027",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_186",
    "data-name": "Tracciato 186",
    d: "M119.11,30.69a9.243,9.243,0,0,0,4.812,6.94A8.325,8.325,0,0,0,119.11,30.69Z",
    transform: "translate(-73.185 -4.424)",
    fill: "#e02027",
    stroke: "#e02027",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_187",
    "data-name": "Tracciato 187",
    d: "M99.3,30.6l-.1-.052a8.448,8.448,0,0,1-11.688,7.38h0a8.324,8.324,0,1,0,16.632.747,8.587,8.587,0,0,0,0-1.12A9.243,9.243,0,0,1,99.3,30.6Z",
    transform: "translate(-53.373 -4.337)",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_188",
    "data-name": "Tracciato 188",
    d: "M126.25,39.106a9.254,9.254,0,0,1-7-7.406",
    transform: "translate(-73.272 -5.057)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecapUserIcon);
export default __webpack_public_path__ + "static/media/recap-user-icon.f51d5850da3d4caed3ee3b4d6dc00038.svg";
export { ForwardRef as ReactComponent };